import * as React from "react";
import { FC, PropsWithChildren } from "react";
import logo from "./assets/images/logo-green@25.png";

export type Props = { sitename: string }

export const AckHeader: FC<PropsWithChildren<Props>> = (props) => {
  const toggle = () => {
    // burger control for responsive settings
    const toggle = document.querySelector(".navbar-burger");
    const menu = document.querySelector(".navbar-menu");
    toggle!.classList.toggle("is-active");
    menu!.classList.toggle("is-active");

    // burger control with dropdown
    const links = menu!.querySelectorAll(".navbar-item");
    links.forEach(link => {
      link.addEventListener("click", () => {
        toggle!.classList.remove("is-active");
        menu!.classList.remove("is-active");
      });
    });
  };
  return (
    <nav className="navbar" role="navigation" aria-label="main navigation">
      <div className="navbar-brand">
        <a className="navbar-item is-size-5" href="#">
          <img className="logo" src={logo} alt="logo"/>Ackbox <strong className="ml-1">{props.sitename}</strong>
        </a>
        <a role="button"
           className="navbar-burger burger"
           aria-label="menu"
           aria-expanded="false"
           data-target="navbar-menu"
           onClick={toggle}>
          <span aria-hidden="true"/>
          <span aria-hidden="true"/>
          <span aria-hidden="true"/>
        </a>
      </div>
      <div id="navbar-menu" className="navbar-menu">
        {props.children}
      </div>
    </nav>
  );
};
